import React from 'react';
import { BsInstagram, BsLinkedin } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  return (
      <div className='app__social'>
        <div>
        <a href='https://www.linkedin.com/in/kristian-besedes/' target='_blank' ><BsLinkedin/></a>
          </div>
          <div>
            <a href='https://www.facebook.com/kristian.besedes/' target='_blank' ><FaFacebookF/></a>
          </div>
    </div>
  )
}

export default SocialMedia
